import { EmptyState } from '@procurify/ui'

import { SpendTracker } from '@webapp/components/Budgets'
import { ErrorBoundary } from '@webapp/components/ErrorBoundary'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { SpendTrackerPresenterStyled } from './styles/SpendTrackerPresenterStyled'
import { useSpendTrackerPresenter } from './useSpendTrackerPresenter'

interface ISpendTrackerPresenterProps {
  expenseUuid: string
}

export const SpendTrackerPresenter = ({
  expenseUuid,
}: ISpendTrackerPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    data: {
      budgetCategories,
      processedBudgetData,
      primaryCategory,
      secondaryCategory,
      secondaryCategorySpend,
      headquartersTimezone,
      uncategorizedSpend,
    },
    states: {
      isSpendTrackerEnabled,
      isSpendTrackerDataLoading,
      isSpendTrackerEmpty,
      isFlexibleSpendTrackingEnabled,
    },
  } = useSpendTrackerPresenter({ expenseUuid })

  if (!isSpendTrackerEnabled) return null

  return (
    <SpendTrackerPresenterStyled>
      <ErrorBoundary boundaryName='SpendTrackerPresenter'>
        {isSpendTrackerEmpty ? (
          <EmptyState
            context='information'
            small
            header={intl.formatMessage(
              isFlexibleSpendTrackingEnabled
                ? messages.emptyStateHeader
                : messages.emptyStateHeaderDeprecated
            )}
            content={intl.formatMessage(messages.emptyStateContent)}
          />
        ) : (
          <SpendTracker
            primaryOrganizationName={primaryCategory?.name}
            secondaryOrganizationName={secondaryCategory?.name}
            isLoading={isSpendTrackerDataLoading}
            budgetCategories={budgetCategories}
            departmentalSpend={secondaryCategorySpend}
            processedBudgetData={processedBudgetData}
            uncategorizedSpend={uncategorizedSpend}
            timeZoneTooltip={headquartersTimezone}
          />
        )}
      </ErrorBoundary>
    </SpendTrackerPresenterStyled>
  )
}
